@if (!isEmergency) {
  <div class="form-group" >
    @for (item of items; track item; let i = $index) {
      <label
        class="custom-input custom-input--checkbox custom-input--pill-complex"
        >
        <input
          type="checkbox"
          [checked]="item.checked"
          [name]="uniqueControlName"
          [value]="item?.answer"
          (change)="checkSelect(i)">
          <span class="custom-input__indi"></span>
          <span class="custom-input__label">
            <span class="custom-input__label-text">
              <h5>{{item?.answer}}</h5>
              @if (item?.checked) {
                <p class="helper-text">{{item?.detail}}</p>
              }
            </span>
            @if (item?.checked) {
              <a  href="javascript:" (click)="getMiniFormQuestions(item)" data-toggle="modal" class="custom-input__label-action icon-hover" data-tooltip="tooltip"
                data-placement="top" title="" data-original-title="Edit">
                <svg class="icon">
                  <use xlink:href="#edit-underline"></use>
                </svg>
              </a>
            }
          </span>
        </label>
      }
    </div>
  }

